import { useState, useEffect } from 'react';
import PubSub from 'pubsub-js'

import auth from '../services/auth';

function useUser() {
  const [user, setUser] = useState(auth.getUser());
  const [isInitializing, setIsInitializing] = useState(auth.requiresSessionInitialization());

  useEffect(() => {
    let active = true;
    auth.initializeSession()
      .then(initializedUser => {
        if (active) setUser(initializedUser);
      })
      .finally(() => {
        if (active) setIsInitializing(false);
      });

    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    var token = PubSub.subscribe('LOGIN', (msg, data) => {
      setUser(auth.getUser())
    });

    return () => {
      PubSub.unsubscribe(token);
    }
  }, []);

  useEffect(() => {
    var token = PubSub.subscribe('LOGOUT', (msg, data) => {
      setUser(auth.getUser())
    });

    return () => {
      PubSub.unsubscribe(token);
    }
  }, []);

  useEffect(() => {
    var token = PubSub.subscribe('REFRESH', (msg, data) => {
      setUser(auth.getUser())
    });

    return () => {
      PubSub.unsubscribe(token);
    }
  }, []);

  useEffect(() => {
    var token = PubSub.subscribe('UNSUB', (msg, data) => {
      setUser(auth.getUser())
    });

    return () => {
      PubSub.unsubscribe(token);
    }
  }, []);

  return [user, isInitializing];
}

export default useUser;
